export enum StatusType {
  DRAFTS = "drafts",
  SUBMITTED = "submitted",
  RESUBMITTED = "resubmitted",
  ASSIGNED = "assigned",
  ASSESSED = "assessed",
  AWARDED = "awarded",
  DENIED = "denied",
}
